// © Microsoft Corporation. All rights reserved.

import { MeControlComponentProps as BaseMeControlComponentProps, MeControlComponentCssClasses, MeControlComponentHandledProps } from "./MeControlComponent.props";
import manageJss, { ManagedJSSProps } from "@microsoft/fast-jss-manager-react";

import { MeControlComponent as BaseMeControlComponent } from "./MeControlComponent";
import { DesignSystem } from "@microsoft/fast-components-styles-msft";

/*
 * The type returned by manageJss type is very complicated so we'll let the
 * compiler infer the type instead of re-declaring just for the package export
 */
const MeControlComponent = manageJss<MeControlComponentCssClasses, DesignSystem>()(BaseMeControlComponent);
type MeControlComponent = InstanceType<typeof MeControlComponent>;

type MeControlComponentProps = ManagedJSSProps<BaseMeControlComponentProps, MeControlComponentCssClasses, DesignSystem>;

export {
    MeControlComponentHandledProps,
    MeControlComponent,
    MeControlComponentProps
};
